import { Data } from "@singularsystems/neo-core";
import { LifeTime } from "st-app/Services/AppDataService";
import ParticipantGrade from "../Models/ParticipantGrade";
import { AppService, Types } from "../ParticipantsTypes";
import CountryDTO from '../Models/DTOs/CountryDTO';
import IDType from 'st-common/Participants/Models/IDType';
import IDTypeLookup from 'st-common/Participants/Models/IDTypeLookup';
import CountryLookup from 'st-common/Participants/Models/CountryLookup';


export default class ParticipantsDataCache extends Data.CachedDataService {
    constructor(
        private catalogueApiClient = AppService.get(Types.Participants.ApiClients.CatalogueApiClient),
        public participantApiClient = AppService.get(Types.Participants.ApiClients.MainApiClient)
    ) {
        super();
    }

    public participantGrades = this.registerList(ParticipantGrade, this.catalogueApiClient.getParticipantGrades, LifeTime.Long);
    public secondments = this.register(this.participantApiClient.getSecondments, LifeTime.Long)
    public countries  = this.registerList(CountryDTO, this.catalogueApiClient.getCountries, LifeTime.Long);
    public idTypes  = this.registerList(IDType, this.catalogueApiClient.getIDTypes, LifeTime.Long);

    public idTypesLookupDataSource = new Data.ApiClientLookupDataSource(() => this.catalogueApiClient.getIDTypes(), IDTypeLookup);

    public countriesLookupDataSource = new Data.ApiClientLookupDataSource(() => this.catalogueApiClient.getCountries(), CountryLookup);
}